/* MrCOLOMBO Visuelle Hilfe - Accessibility Panel Controller
   Eigene Implementierung, keine externe App. localStorage-persistent. */
(function () {
  'use strict';

  var KEY = 'mrc:a11y';

  var DEFAULT = {
    textSize: 0,
    letterSpacing: 0,
    lineHeight: 0,
    contrast: 'normal',
    linksUnderlined: false,
    readableFont: false,
    hideImages: false,
    noAnim: false,
    bigCursor: false,
    focusHighlight: false
  };

  function read() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY));
      return Object.assign({}, DEFAULT, s || {});
    } catch (e) {
      return Object.assign({}, DEFAULT);
    }
  }
  function write(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }

  function apply(state) {
    var html = document.documentElement;
    var keep = (html.className || '').split(/\s+/).filter(function (c) {
      return c && c.indexOf('mrc-a11y--') !== 0;
    });

    if (state.textSize === 1) keep.push('mrc-a11y--text-110');
    if (state.textSize === 2) keep.push('mrc-a11y--text-125');
    if (state.textSize === 3) keep.push('mrc-a11y--text-150');

    if (state.letterSpacing === 1) keep.push('mrc-a11y--letter-1');
    if (state.letterSpacing === 2) keep.push('mrc-a11y--letter-2');

    if (state.lineHeight === 1) keep.push('mrc-a11y--line-1');
    if (state.lineHeight === 2) keep.push('mrc-a11y--line-2');

    if (state.contrast === 'high') keep.push('mrc-a11y--contrast-high');
    if (state.contrast === 'inverted') keep.push('mrc-a11y--contrast-inverted');

    if (state.linksUnderlined) keep.push('mrc-a11y--links-underlined');
    if (state.readableFont) keep.push('mrc-a11y--readable-font');
    if (state.hideImages) keep.push('mrc-a11y--hide-images');
    if (state.noAnim) keep.push('mrc-a11y--no-anim');
    if (state.bigCursor) keep.push('mrc-a11y--big-cursor');
    if (state.focusHighlight) keep.push('mrc-a11y--focus-highlight');

    html.className = keep.join(' ');
  }

  // Boot: apply persisted state immediately (vor erstem Paint)
  var state = read();
  apply(state);

  function getPanel() { return document.getElementById('mrc-a11y-panel'); }
  function getBackdrop() { return document.getElementById('mrc-a11y-panel-backdrop'); }
  function getTrigger() { return document.getElementById('mrc-footer-a11y-slot'); }

  function openPanel() {
    var p = getPanel(); var b = getBackdrop();
    if (!p) return;
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    if (b) b.classList.add('is-open');
    var firstFocus = p.querySelector('[data-a11y-close]');
    if (firstFocus) setTimeout(function () { firstFocus.focus(); }, 50);
  }
  function closePanel() {
    var p = getPanel(); var b = getBackdrop();
    if (!p) return;
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden', 'true');
    if (b) b.classList.remove('is-open');
    var t = getTrigger();
    if (t) t.focus();
  }
  function togglePanel() {
    var p = getPanel();
    if (!p) return;
    if (p.classList.contains('is-open')) closePanel(); else openPanel();
  }

  function syncUI() {
    var p = getPanel();
    if (!p) return;

    p.querySelectorAll('[data-a11y-steps]').forEach(function (group) {
      var key = group.dataset.a11ySteps;
      var val = state[key];
      group.querySelectorAll('.mrc-a11y-step').forEach(function (btn) {
        var on = String(btn.dataset.val) === String(val);
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });

    p.querySelectorAll('[data-a11y-contrast]').forEach(function (btn) {
      var on = btn.dataset.a11yContrast === state.contrast;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    p.querySelectorAll('[data-a11y-toggle]').forEach(function (t) {
      var key = t.dataset.a11yToggle;
      var on = !!state[key];
      t.classList.toggle('is-on', on);
      var inp = t.querySelector('input[type="checkbox"]');
      if (inp) inp.checked = on;
    });
  }

  function bindUI() {
    var trigger = getTrigger();
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        togglePanel();
      });
    }

    var p = getPanel();
    if (!p) return;

    var closeBtn = p.querySelector('[data-a11y-close]');
    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    var bd = getBackdrop();
    if (bd) bd.addEventListener('click', closePanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && p.classList.contains('is-open')) closePanel();
    });

    p.querySelectorAll('[data-a11y-steps] .mrc-a11y-step').forEach(function (b) {
      b.addEventListener('click', function () {
        var group = b.closest('[data-a11y-steps]');
        var key = group.dataset.a11ySteps;
        state[key] = parseInt(b.dataset.val, 10) || 0;
        write(state); apply(state); syncUI();
      });
    });

    p.querySelectorAll('[data-a11y-contrast]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.contrast = b.dataset.a11yContrast;
        write(state); apply(state); syncUI();
      });
    });

    p.querySelectorAll('[data-a11y-toggle]').forEach(function (t) {
      var inp = t.querySelector('input[type="checkbox"]');
      function toggle() {
        var key = t.dataset.a11yToggle;
        state[key] = !state[key];
        write(state); apply(state); syncUI();
      }
      t.addEventListener('click', function (e) {
        if (e.target === inp) return;
        e.preventDefault();
        toggle();
      });
      if (inp) {
        inp.addEventListener('change', function () {
          var key = t.dataset.a11yToggle;
          state[key] = inp.checked;
          write(state); apply(state); syncUI();
        });
      }
    });

    var reset = p.querySelector('[data-a11y-reset]');
    if (reset) reset.addEventListener('click', function () {
      state = Object.assign({}, DEFAULT);
      write(state); apply(state); syncUI();
    });

    syncUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindUI);
  } else {
    bindUI();
  }

  window.MRCA11y = { open: openPanel, close: closePanel, toggle: togglePanel, read: read };
})();
